module.exports = __webpack_public_path__ + "static/media/kids_34.ff24ca01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_34.jpg
// module id = 5890
// module chunks = 0